import { companiesCollection } from "./firebase";

export const fetchCompanies = async () => {
  const snapshot = await companiesCollection.get();
  return snapshot?.docs?.map((doc) => ({
    ...doc.data(),
    id: doc.id,
    companyID: doc.id,
  }));
};

// Fetch a single company by ID
export const fetchCompany = async (id) => {
  const doc = await companiesCollection.doc(id).get();
  if (doc.exists) {
    return { ...doc.data(), id: doc.id, companyID: doc.id };
  }
  throw new Error("Company not found");
};

export const fetchCompanyMatch = async (companyID) => {
  const snapshot = await companiesCollection
      .where("companyID", "==", companyID)
      .get();
  if (!snapshot.empty) {
      return snapshot.docs[0].data(); // Return the first matching company
  }
  return null; // Return null if no match
};